import { settingsPagePaths, settingsUrlBase } from 'pages/Settings/paths';
import { PlanPage } from './PlanPage';
import { UsagePage } from './UsagePage';
import { BillingDetailsPage } from './DetailsPage';
import { BillingRootPage } from './Rootpage';
import { BillingInvoicesPage } from './InvoicesPage';

export const BASE_BILLING_SETTINGS_PATH = `${settingsUrlBase}/${settingsPagePaths.billing}`;

export const BILLING_DETAILS_PATH = `${BASE_BILLING_SETTINGS_PATH}/details`;

export const BILLING_USAGE_PATH = `${BASE_BILLING_SETTINGS_PATH}/usage`;

export const BILLING_CHANGE_PLAN_PATH = `${BASE_BILLING_SETTINGS_PATH}/plan`;

export const BILLING_VIEW_INVOICES_PATH = `${BASE_BILLING_SETTINGS_PATH}/invoices`;

export const subroutes = () => {
  return {
    [BASE_BILLING_SETTINGS_PATH]: {
      path: BASE_BILLING_SETTINGS_PATH,
      label: (t) => t('Billing'),
      component: BillingRootPage,
      exact: true,
      access: {
        hideFromNav: true,
        checkBillingPermission: (permissions) => {
          return (
            permissions.canViewBillingSettingsMenuItem &&
            permissions.canSelfServeBilling
          );
        },
      },
    },
    [BILLING_USAGE_PATH]: {
      path: BILLING_USAGE_PATH,
      label: (t) => t('Usage'),
      component: UsagePage,
      exact: true,
      access: {
        hideFromNav: false,
        checkBillingPermission: (permissions) => {
          return permissions.canViewUsage;
        },
      },
    },
    [BILLING_CHANGE_PLAN_PATH]: {
      path: BILLING_CHANGE_PLAN_PATH,
      label: (t) => t('Manage Plans'),
      component: PlanPage,
      exact: true,
      access: {
        hideFromNav: false,
        checkBillingPermission: (permissions) => {
          return permissions.canManagePlans;
        },
      },
    },
    [BILLING_DETAILS_PATH]: {
      path: BILLING_DETAILS_PATH,
      label: (t) => t('Billing Settings'),
      component: BillingDetailsPage,
      exact: true,
      access: {
        hideFromNav: false,
        checkBillingPermission: (permissions) => {
          return permissions.canViewPaymentMethods;
        },
      },
    },
    [BILLING_VIEW_INVOICES_PATH]: {
      path: BILLING_VIEW_INVOICES_PATH,
      label: (t) => t('Invoices'),
      component: BillingInvoicesPage,
      exact: true,
      access: {
        hideFromNav: false,
        checkBillingPermission: (permissions) => {
          return permissions.canViewInvoices;
        },
      },
    },
  };
};
